import BaseMarker from "./base_marker";

export default class ChubbyMarker extends BaseMarker {
  static anchor() {
    return "bottom";
  }

  static allowIconFillInjection() {
    return true;
  }

  static iconStyle() {
    return {
      "width": "14px",
      "position": "absolute",
      "left": "13px",
      "top": "13px",
    };
  }

  static iconSvgAttributes() {
    return { "fill": "#8a6bee" };
  }

  static markerStyle() {
    return { "width": "40px" };
  }

  static markerSvgAttributes() {
    return {
      "fill": "#8a6bee",
      "stroke": "#b8a6f4",
      "stroke-width": 2,
      "stroke-opacity": 1
    };
  }

  static markerType() {
    return "chubby";
  }

  static dimensions() {
    return {
      "width": 41,
      "height": 41
    };
  }
}
